import { useContext } from "react"
import CachedQueryParamsContext from "../CachedQueryParamsContext"

const useCachedQueryParamsContext = () => {
  const providedValue = useContext(CachedQueryParamsContext)

  return { ...providedValue }
}

export default useCachedQueryParamsContext
